module.exports = __webpack_public_path__ + "static/img/banner5.e185b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner5.png
// module id = Yix9
// module chunks = 0